const calendarService = require('calendarService');
const moment = require('moment');
const fullCalendar = require('fullCalendar');
const idealTextColor = require('idealTextColor');
const loader = require('loader');
const model = require('modal');
const pickatime = require('pickatime');
import getAPIPath from '../modules/api-location';


// Build Calendar (user & season plan calendar)
const calendar = (function() {
  const $calendar = $('.calendar');

  const parseCalEvent = function (event, time, toDelete) {
    const postableEvent = {};

    postableEvent.id = event.id;
    postableEvent.club_name = event.club_name;
    postableEvent.team_name = event.team_name;
    postableEvent.start_date = event.start.format('YYYY-MM-DD'); // '2017-11-23';
    postableEvent.start_time = time; // '02:02';
    postableEvent.to_delete = toDelete;
    return JSON.stringify(postableEvent);
  };


  const postCalendarEventChangesService = function(calEvent, teamID, rollbackFn) {
    return $.ajax({
      url: `${getAPIPath}commandapi/calendar/${teamID}`,
      type: 'post',
      data: calEvent,
      error() {
        rollbackFn(calEvent);
      },
      async: true,
      xhrFields: {
        withCredentials: true,
      },
    });
  };


  const rollbackFn = function(event) {
    location.reload(); // fix anything that went wrong
  };


  const eventDrop = function(event, delta, revertFunc, jsEvent, ui, view) {
    event.data = { calEvent: event, callback: getTimeChangeDelete, revertFunc };
    displayModal(event);
  };

  const shouldDisplayEvent = function(teamName) {
    if ($('#team-selector').length) {
      return ['all', teamName].indexOf($('#team-selector').val()) >= 0; // if team_name or all selected return true
    }
    return true;
  };

  const optimisticChanges = function(calEvent, toDelete, time) {
    if (toDelete === true) {
      $calendar.fullCalendar('removeEvents', calEvent.id.toString());
    }
    if (time === '') {
      calEvent.start.hours('00');
      calEvent.start.minutes('00'); // mimic what happens when no time set
    } else {
      const timeList = time.split(':');
      calEvent.start.hours(timeList[0]);
      calEvent.start.minutes(timeList[1]);
    }
    $calendar.fullCalendar('refetchEvents');
  };


  const getTimeChangeDelete = function(params) {
    const time = $('#hidden-start > :input').attr('value');
    const jsonEvent = parseCalEvent(params.calEvent, time, params.toDelete);

    optimisticChanges(params.calEvent, params.toDelete, time);

    postCalendarEventChangesService(jsonEvent, params.calEvent.id, rollbackFn);
  };


  const eventRender = function(event, element) {
    const currentView = $calendar.fullCalendar('getView');
    let textColor = '';
    const clubName = event.club_name;
    const teamName = event.team_name;
    const $teamInfo = $(`<div class="cal-team-info"><span class="club-name">${clubName}</span><span class="team-name">${teamName}</span></div>`);

    if (event.colours !== null) {
      textColor = $(window).idealTextColor(event.colours);
    }

    if (currentView.name === 'month') {
      const monthTime = element.find('.fc-time').html();
      if (monthTime === '00:00') {
        element.addClass('no-time');
      }

      element.css({ 'background-color': event.colours, color: textColor });

      if ($calendar.is('#user-calendar')) {
        element.find('.fc-time').after($teamInfo);
      }
    } else {
      const listTime = element.find('.fc-list-item-time').html();
      const timeElem = `<span class="list-time">${listTime}</span>`;

      if (listTime === '00:00 - 01:00') {
        element.addClass('no-time');
      }

      element.find('.fc-list-item-title').prepend(timeElem);

      if ($calendar.is('#user-calendar')) {
        element.find('.list-time').after($teamInfo);
        $teamInfo.find('.club-name').after('<span> - </span>');
      }

      element.find('.fc-list-item-title > *').css({ 'background-color': event.colours, color: textColor });
    }
    return shouldDisplayEvent(event.team_name);
  };

  const editClickListener = function($edit, event) {
    $edit.off('click');
    $edit.on('click', { calEvent: event, callback: getTimeChangeDelete }, displayModal);
  };

  const addEdit = function(event, elem, view) {
    let editableText = '';
    if (event.editable === true) {
      editableText = 'editable-btn';
    }
    elem.closest('td').append(`
      <div class="edit-btn-wrapper ${editableText}">
        <button class="edit-btn btn btn-S btn-green">
          <div class="icon-left icon-left-small " >
            <svg class="icon fill-white icon-S"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-edit"></use></svg>
                <div class="btn-text">
                    Edit
                </div>
          </div>
        </button>
      </div>
    `);


    const $edit = elem.siblings().find('.edit-btn');
    editClickListener($edit, event);
  };

  const calculateExtraTimeClass = function(calEvent) {
    if (calEvent.title === 'Match Day' && (calEvent.url === '#' || calEvent.url === '')) {
      return 'hidden';
    }
    return '';
  };

  const displayModal = function(event) {
    let revertFn;
    if (event.data.hasOwnProperty('revertFunc')) {
      revertFn = event.data.revertFunc;
    }
    const defaultTime = event.data.calEvent.start.format('h:mm A');
    const params = { calEvent: event.data.calEvent, toDelete: false };
    const extraTimeClass = calculateExtraTimeClass(event.data.calEvent);

    $(window).modal({
      title: 'Edit Event? ',
      content: `
        <div class="form-group">
            <div class="time ${extraTimeClass}">
              <input id="start-time" class="training-timepicker input-lg" type="text" placeholder="Pick a start time (optional)" value="${defaultTime}"> \
              <div id="hidden-start" type="hidden" name="time-input"></div>
              <label for="start-time">Pick a start time (optional)</label>
            </div>
          <br/> \
          <button id="delete-event-btn" class="btn border-red">
            <div class="icon-left icon-left-small">
              <svg class="icon icon-S fill-red"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-remove-circle"></use></svg>
              Delete Event
             </divclass>
          </button>
        </div>
      `,
      confirmText: 'Confirm',
      complete: event.data.callback,
      completeCallbackParams: params,
      cancel: revertFn,
    });

    $('#delete-event-btn').on('click', function(e) {
      params.toDelete = true;
      event.data.callback(params);
      $(window).modal().closeModal();
    });

    $('.training-timepicker').pickatime({
      container: 'body',
      format: 'h:i A',
      formatSubmit: 'HH:i',
      hiddenName: true,
      containerHidden: '#hidden-start',
      interval: 15,
    });
  };


  const buildCalendar = function(options) {
    $('window').hideLazyLoad($('.calendar'));
    $calendar.fullCalendar(options);
  };


  const viewportOptions = function(options) {
    const screenWidth = $(window).width();
    if (screenWidth < 700) {
      options.defaultView = 'listMonth';
    } else {
      options.defaultView = 'month';
    }
    buildCalendar(options);
  };


  const calendarOptions = function(response) {
    const options = { // Create an options object
      firstDay: 1, // Monday
      header: {
        left: 'prev,next today title',

        right: 'listMonth,month',
      },
      timeFormat: 'h:mm a',
      editable: true,
      events: response.data,
      eventDrop,
      eventRender,
      eventAfterRender: addEdit,
      startEditable: true,
    };
    viewportOptions(options);
  };


  const calendarEvents = function() {
    const teamID = $calendar.attr('data-team-id');
    getCalendarEventsService(teamID, calendarOptions);
  };


  const addLoader = function() {
    $('window').lazyLoad($('.calendar'));
    calendarEvents();
  };

  const teamChangeListener = function() {
    $('#team-selector').on('change', function() {
      $('.calendar').fullCalendar('refetchEvents');
    });
  };


  const init = function() {
    if ($calendar.length) {
      addLoader();
      teamChangeListener();
    }
  };

  return {
    init,
  };
}());

calendar.init();



// WEBPACK FOOTER //
// ./library/js/modules/calendar.js